export interface TokenStringFilter{
	(tokenString:string):string;
}

// https://regex101.com/r/friuBF/1
// Captues all tokens of the flavor "[@Key=value]phrase[/]"
const tokenRegex = /\[[\w@=\/]+\]/ig;

/**
* @ngdoc filter
* @name phoenix.filter:pxTokenString
* @kind function
* 
* @description
*   Facilitates replacement of tokens in a tokenized string.
*	
*/	
export function TokenStringFilter() {
	return function tokenStringFilterReplace(str:string) {
		if (!str) {
			return str;
		}

		return str.replace(tokenRegex, '');
	};
}


// WEBPACK FOOTER //
// ./src/phoenix/filters/tokenString.ts